
import { eoRendererMixin, metaDataMixin, dateFormatMixin, notificationsMixin } from '~/mixins'

export default {
  mixins: [
    dateFormatMixin,
    eoRendererMixin,
    notificationsMixin,
    metaDataMixin,
  ],
  layout: 'bijbelopen',
  async asyncData ({ $api, $config, error, params: { slug } }) {
    const {
      data: {
        items: [
          article = {},
        ] = [],
      } = {},
    } = await $api.articles.getOneBySlug(slug, {
      domain: $config.preprEnvironmentDomainBijbelopen,
    })

    if (!article.id) {
      error({
        statusCode: 404,
        message: '(404) Overdenking niet gevonden',
        context: `Couldn't find publication: ${slug}.`,
        severity: 'info',
      })
      return false
    }

    return {
      ...article,
    }
  },
  data () {
    return {
      id: null,
      changedOn: null,
      publishOn: null,
      slug: null,
      readTime: null,
      modelId: null,
      modelName: null,
      environmentId: null,
      title: null,
      subtitle: null,
      featuredVideo: null,
      hero: null,
      intro: null,
      likes: null,
      content: [],
      seo: null,
      social: null,
      tags: null,
      stories: null,
      topic: null,
      program: null,
      podcast: null,
      author: null,
      type: null,
      location: null,
      event: null,
      campaign: null,
      persons: null,
      relatedArticles: [],
      callToAction: null,
      amountRelatedArticlesAnywhere: 0,
      amountRelatedArticlesCommunity: 0,
    }
  },
  computed: {
    isAuthorExternal () {
      return this.author?.role?.some((role) => {
        return role.slug === 'gastauteur'
      })
    },
    labels () {
      const labels = []

      if (this.stories && this.stories.length) {
        this.stories.forEach((story) => {
          labels.push({
            slug: story.slug,
            name: story.name,
            to: `/rubriek/${story.slug}`,
          })
        })
      }

      if (this.tags && this.tags.length) {
        this.tags.forEach((tag) => {
          labels.push({
            slug: tag.slug,
            name: tag.name,
            to: `/alles-over/${tag.slug}`,
          })
        })
      }

      return labels
    },
    shareUrlFacebook () {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.$config.baseUrlCanonical + this.$route.path}`
    },
    shareUrlTwitter () {
      return `https://twitter.com/intent/tweet?text=${this.$config.baseUrlCanonical + this.$route.path}`
    },
    shareUrlWhatsApp () {
      return `https://api.whatsapp.com/send?text=${this.$config.baseUrlCanonical + this.$route.path}`
    },
  },
  mounted() {
    if (!process.server && !window.BibleTagger) {
      const script = document.createElement("script")
      script.type = "text/javascript"
      script.async = true
      script.src = "https://bijbel.eo.nl/libs/bibletagger/bibletagger.min.js"
      document.head.appendChild(script)
    } else {
      window.BibleTagger.scan(document.body)
    }
  },
  methods: {
    onShare (method) {
      // Send event to Prepr
      window.prepr('event', 'Share', { constraint: true })

      // Send event to GTM
      if (this.$gtm) {
        this.$gtm.push({
          event: 'eo_share',
          'method': method,
          'content_type': 'article',
          'item_id': this.id,
        })
      }
    },
  },
  jsonld () {
    return {
      '@context': 'http://schema.org',
      '@type': 'Article',
      datePublished: this.publishOn,
      dateModified: this.changeOn,
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': this.$config.baseUrlCanonical + this.$route.path,
      },
      headline: this.seo && this.seo.title,
      description: this.seo && this.seo.description,
      image: this.hero,
      author: {
        '@type': 'Person',
        name: this.author && this.author.name,
        // @todo: add image of author (if it is available in first call)
        // @todo: add url of author detailpage as 'mainEntityOfPage'
        // @todo: add url of author detailpage as 'sameAs'
      },
      publisher: {
        '@type': 'Organization',
        name: 'EO',
        logo: {
          '@type': 'ImageObject',
          url: this.$config.baseUrlCanonical + require('~/assets/logo/evangelische-omroep.webp'),
        },
      },
    }
  },
}
